import React from 'react';
import PropTypes from 'prop-types';
import { FileDrop } from 'react-file-drop';
import { makeCss } from '../../../../knock-design-system';
import { DRAG_OVER_ACTIVE_CLASS } from './constants';

const useCss = makeCss((theme) => ({
  fileDropzone: {
    height: 'inherit',
    width: 'inherit',
    '& .file-drop-target': {
      height: 'inherit',
    },
    [`& .${DRAG_OVER_ACTIVE_CLASS}`]: {
      '& .MuiCard-root': {
        backgroundColor: theme.palette.primary[50],
      },
      '& .overlay': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        visibility: 'visible',
      },
    },
  },
}));

const FileDropzone = ({
  acceptedFileFormats,
  children,
  className,
  dropFrameRef,
  fileInputLabel,
  fileInputRef,
  handleDropTargetClick,
  handleFile,
  handleOnFrameDragEnter,
  isMultiFile,
}) => {
  const css = useCss();

  const acceptedFileFormatString = acceptedFileFormats.join(',');

  return (
    <React.Fragment>
      <FileDrop
        className={className}
        css={css.fileDropzone}
        draggingOverTargetClassName={DRAG_OVER_ACTIVE_CLASS}
        frame={dropFrameRef.current}
        onFrameDragEnter={handleOnFrameDragEnter}
        onDrop={handleFile}
        onTargetClick={handleDropTargetClick}
      >
        {children}
      </FileDrop>

      <input
        accept={acceptedFileFormatString}
        aria-label={fileInputLabel}
        aria-hidden
        hidden
        multiple={isMultiFile}
        onChange={(e) => handleFile(e.target.files)}
        ref={fileInputRef}
        type="file"
      />
    </React.Fragment>
  );
};

FileDropzone.propTypes = {
  acceptedFileFormats: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  className: PropTypes.string,
  dropFrameRef: PropTypes.object,
  fileInputLabel: PropTypes.string,
  fileInputRef: PropTypes.object,
  handleDropTargetClick: PropTypes.func,
  handleFile: PropTypes.func,
  handleOnFrameDragEnter: PropTypes.func,
  isMultiFile: PropTypes.bool,
};

export default FileDropzone;
